/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useTranslation } from "react-i18next";
import { customStylesFinancialSummary } from "./customStylesFinancialSummary";
import { WalletsMergedTableColumns } from "./WalletsMergedTableColumns";
import { getGroupsWallets, getGroupsWalletsTotal, getInvestedTotal } from "../../requests/getHomeReports";
import { WalletsMergedTableSearch } from "./WalletsMergedTableSearch";
import { debounce } from "lodash";

// Estilos personalizados
export const WalletsMergedTable = () => {
  const { t } = useTranslation();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [fullName, setfullName] = useState('');
  const [address, setAddress] = useState('');
  const [mergedIds, setMergedIds] = useState([]);
  const [showInvested, setshowInvested] = useState(true);
  const [totalInvested, setTotalInvested] = useState("");
  const [totalAccount, setTotalAccount] = useState("");

  const fetchData = async (page, perPage, fullName, address) => {
    setLoading(true);
    try {
      const offset = (page - 1) * perPage;
      const walletsData = await getGroupsWallets(perPage, offset, fullName, address)
      setData(walletsData);
      setMergedIds([...new Set(walletsData.flatMap(item => item.user_ids))]);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      await fetchData(page, perPage, fullName, address);
    })();
  }, [page, perPage]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    (async () => {
      setTotalRows(await getGroupsWalletsTotal(fullName, address));
    })();
  }, []);

  const handlePerRowsChange = (newPerPage, newPage) => {
    setPerPage(newPerPage);
    setPage(newPage);
  };

  const handleFullNameChange = (e) => {
    setfullName(e.target.value);
  };

  const handleAddressChange = (e) => {
    setAddress(e.target.value);
  };

  useEffect(() => {
    (async () => {
      if (data.length > 0 && data.length < 9 && (fullName || address)) {
        const amountInvested = await getInvestedTotal(mergedIds)
        setTotalInvested(amountInvested);
        const withdrawnTotal = data.reduce((sum, wallet) => sum + (Number(wallet.total_balance) || 0), 0);
        setTotalAccount(amountInvested + withdrawnTotal)
        setshowInvested(false);
      } else {
        setshowInvested(true);
      }
    })();
  }, [mergedIds, perPage]);

  const fetchDataDelayed = async (page, perPage, fullName, address) => {
    await fetchData(page, perPage, fullName, address);
    setTotalRows(await getGroupsWalletsTotal(fullName, address));
  };
  const debouncedFetch = React.useCallback(debounce(fetchDataDelayed, 1500), []);

  useEffect(() => {
    (async () => {
      await debouncedFetch(page, perPage, fullName, address);
    })();
  }, [fullName, address]);

  const customStyles = customStylesFinancialSummary();
  const columns = WalletsMergedTableColumns(showInvested, totalInvested, totalAccount);

  return (
    <div className="mx-auto bg-white mt-10 p-6 rounded-lg shadow-lg">
      <h2 className="text-xl font-bold text-center mb-4">{t('cash_wallet_title')} - Billions Trade Club</h2>
      <p className="my-2">{t('cash_wallet_desc')}</p>
      <WalletsMergedTableSearch
        fullName={fullName}
        handleFullNameChange={handleFullNameChange}
        address={address}
        handleAddressChange={handleAddressChange}
      />

      <DataTable
        customStyles={customStyles}
        highlightOnHover
        columns={columns}
        data={data}
        progressPending={loading}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handlePerRowsChange}
        paginationPerPage={perPage}
        paginationRowsPerPageOptions={[10, 25, 50, 100, 250, 500, 1000]}
      />
    </div>
  );
};
